// extracted by mini-css-extract-plugin
export var divider = "_1f-0";
export var dividerText = "_1f-1";